module.exports = __webpack_public_path__ + "static/carrot-659a2b1f628436a85d8c283104785411.svg";